<template>
  <div class="login-bg">
    <div class="header">
      <div class="flex">
        <router-link to="/">
          <img class="pointer" src="~@/assets/img/main/logo.png" alt="logo" />
        </router-link>
        <el-divider direction="vertical" class="divider"></el-divider>
        <div class="title">{{ title }}</div>
      </div>
    </div>
    <div class="content">
      <slot></slot>
    </div>
    <div class="footer">
      <div class="line">
        <div class="linkBox">
          <span class="bold">{{ $t("footer.link") }}：</span>
          <span class="link pointer" v-for="item in linkList" :key="item.linkId"
            ><a :href="item.url" target="_blank" rel="nofollow">{{
              item.name
            }}</a></span
          >
        </div>
      </div>
      <div class="line">
        <span class="link ba pointer">
          <a target="_blank" href="http://beian.miit.gov.cn/">
            浙ICP备2023011991号-2
          </a>
        </span>
        <span class="link ba pointer">
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010802009779"
          >
            浙公网安备 33010802009779号
          </a>
        </span>
        <span class="link ba pointer">
          <a target="_blank" href="http://beian.miit.gov.cn"> 工信部网站 </a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Icon1 from '@/assets/img/main/footer/footer_icon_1.png'
import Icon2 from '@/assets/img/main/footer/footer_icon_2.png'
import Icon3 from '@/assets/img/main/footer/footer_icon_3.png'
import Icon4 from '@/assets/img/main/footer/footer_icon_4.png'

export default {
  props: {
    title: {
      type: String,
      default: '欢迎登录'
    }
  },
  data () {
    return {
      labelList: [
        {
          label: '品类齐全 正品保证',
          icon: Icon1
        },
        { label: '会员特折 全线低价', icon: Icon2 },
        { label: '多仓直发 极速配送', icon: Icon3 },
        { label: '专属客服 一站服务', icon: Icon4 }
      ], // 标签
      linkList: [
        { name: '宁东能源化工基地管委会', url: 'http://ningdong.nx.gov.cn/' },
        {
          name: '宁东科技服务创新平台',
          url: 'http://119.60.5.197:8081/TechnologyPlatform/'
        },
        { name: '宁东公共仪器服务平台', url: 'http://ndkcpip.cn:8022/yqgxpt/' },
        { name: '宁东公共仪器服务平台', url: 'http://www.smend.cn/index.shtml' }
      ] // 友情链接
    }
  },
  mounted () {
    // this.getLinkList()
  },
  methods: {
    // 友情链接公告
    getLinkList () {
      this.$http
        .get('/front/integratedManagement/mgFriendlyLink/showList')
        .then((res) => {
          if (res && res.data && res.data.code === 0) {
            this.linkList = res.data.data || []
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-bg {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  .header {
    height: 112px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 32px 76px;
    background: #fff;
    .flex {
      display: flex;
      align-items: center;
    }
    .divider {
      height: 48px;
      margin: 0 20px;
    }
    .title {
      font-family: AlibabaPuHuiTi;
      font-size: 24px;
      font-weight: 500;
      text-align: center;
      color: #666666;
    }
  }

  .content {
    background-image: url("../../../../assets/img/login/bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 24px;
    min-height: 720px;
    padding-top: 4%;
  }
  .footer {
    .line {
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .labelLine {
      background-color: #1544ce;
    }
    .labelBox {
      width: 1200px;
      display: flex;
      justify-content: space-around;
      align-items: center;
    }
    .labelItem {
      font-family: AlibabaPuHuiTi;
      font-size: 18px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .icon {
      color: #fff;
      margin-right: 6px;
    }

    .bold {
      font-family: AlibabaPuHuiTi;
      font-size: 14px;
      font-weight: bold;
      line-height: 19.6px;
      color: #333333;
      margin-right: 24px;
      flex-shrink: 0;
    }
    .link {
      font-family: AlibabaPuHuiTi;
      font-size: 14px;
      font-weight: normal;
      line-height: 19.6px;
      text-decoration: underline;
      color: #333333;
      margin-right: 24px;
      word-break: keep-all;
      a {
        color: #333333;
      }
    }
    .linkBox {
      width: 1000px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .ba {
      font-family: AlibabaPuHuiTi;
      font-size: 14px;
      line-height: 19.6px;
      color: #999999;
      text-decoration: none;
      a {
        color: #999999;
      }
    }
  }
  .mb-12 {
    margin-bottom: 12px;
  }
}
</style>
